import { Grid, Stack } from '@mui/material';

import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import {
  getAmountProductByLines,
  getMethodIndicatorsAndDiscountTotalbyOrders,
} from '@/services/monitoring';
import BookingTotalIncomes from '@/modules/cash-register/components/money-indicator';
import Loader from '@/commons/loader';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { translates } from '@/utils';
import { CardDetailColumn } from '../components/card-detail-column';

const DailyReport = () => {
  const series = [
    { x: 2016, y: 111 },
    { x: 2017, y: 136 },
    { x: 2018, y: 76 },
    { x: 2019, y: 108 },
    { x: 2020, y: 74 },
    { x: 2021, y: 54 },
    { x: 2022, y: 57 },
    { x: 2023, y: 111 },
  ];

  const { box: cashRegister } = useCashRegisterContext();

  const firstDate = cashRegister?.createdAt ?? dayjs().format('YYYY-MM-DD');
  const lastDate = dayjs(new Date().setDate(new Date().getDate() + 2)).format('YYYY-MM-DD');

  const paramsRequest: Record<string, string | boolean> = { firstDate, lastDate };
  if (cashRegister?.createdAt) {
    paramsRequest.isOpen = true;
  }
  const { isLoading: isLoading2, data: indicatorMethodsAndDiscount } = useQuery({
    queryKey: ['MethodIndicatorsAndDiscount', firstDate, lastDate],
    queryFn: () => getMethodIndicatorsAndDiscountTotalbyOrders(paramsRequest),
    select(data) {
      const information: any[] = [];
      let total = 0;
      Object.keys(data).forEach((key: string) => {
        Object.keys(data[key]).forEach((keylast) => {
          const isValidTips = keylast !== 'tipsWaiter';
          const isValidTipsCompany = keylast !== 'tipsCompany';
          if (key === 'methods') {
            total += Number(data[key][keylast]);
          } else if (isValidTips || isValidTipsCompany) {
            total -= Number(data[key][keylast]);
          }
          if (keylast !== 'tips') information.push({ label: keylast, value: data[key][keylast] });
        });
      });
      return {
        data: information,
        originalData: data,
        total,
      };
    },
    
  });
  const { isLoading, data: data3 } = useQuery({
    queryKey: ['monitor', 'daily-report', 'type-product', firstDate, lastDate],
    queryFn: () => getAmountProductByLines(paramsRequest),
    select(dataTemp) {
      const categories: string[] = [];
      const data: number[] = [];
      dataTemp.forEach((element: any) => {
        categories.push(element.line.toUpperCase());
        data.push(parseInt(element.quantity, 10));
      });
      return {
        categories,
        values: [
          {
            data,
          },
        ],
      };
    },
  });

  if (isLoading || isLoading2) {
    return <Loader fullScreen />;
  }

  // const dataText = [1, 2];
  return (
    <Grid container spacing={3} marginY={1} px={3}>
      <Grid item xs={12} md={6}>
        <Stack justifyContent="center" alignItems="center">
          <CardDetailColumn data={data3} isCurrency title={translates.amountProductByLines} />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <BookingTotalIncomes
          total={indicatorMethodsAndDiscount?.originalData?.tips?.tipsWaiter ?? 0}
          title={translates.tipsMoment}
          chart={{
            series,
          }}
        />
      </Grid>
      {/* {dataText.map((i, index) => (
        <Grid item xs={12} md={6} marginBottom={5} key={index}>
          <Stack justifyContent="center" alignItems="center">
            <CardDetailText />
          </Stack>
        </Grid>
      ))} */}
    </Grid>
  );
};

export default DailyReport;
